import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { fromNowFR } from "@/lib/utils";

type Props = {
  type: "forum" | "user" | "thread";
  /** The clickable target rendered inside the card (link to the entity). */
  children: React.ReactNode;
  createdAt: string;
  onRemove: () => void;
};

/**
 * FollowCard — mobile row for /follows.
 *
 *   ┌──────────────────────────────────────────┐
 *   │ [forum]                            [X]   │
 *   │ Forum name (link)                        │
 *   │ il y a 3 jours                           │
 *   └──────────────────────────────────────────┘
 */
export function FollowCard({ type, children, createdAt, onRemove }: Props) {
  return (
    <article className="rounded-lg border border-border bg-surface p-4 flex items-start gap-3 transition-colors hover:border-border-strong">
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <Badge variant="secondary" className="self-start">
          {type}
        </Badge>
        <div className="text-sm">{children}</div>
        <span className="text-xs text-foreground-muted">{fromNowFR(createdAt)}</span>
      </div>
      <Button
        size="icon"
        variant="ghost"
        onClick={onRemove}
        aria-label="Retirer ce suivi"
        className="shrink-0"
      >
        <X className="size-4" />
      </Button>
    </article>
  );
}
